import React, { useEffect, useState } from 'react';
import ApacheEcharts from '../../ApacheEcharts';
import "./GraficoLinha.css";

function GraficoLinha({ dadosGrafico }) {

    const { titulo, dados, mesAno } = dadosGrafico;
    const { mes, ano } = mesAno;

    const [option, setOption] = useState({});
    const style = { width: "100%", height: "200px", padding: "0px" };

    useEffect(() => {
        const dataxAxis = [];
        const dataRealizado = [];
        const dataMeta = [];
        const dataAnoAnterior = [];

        for (let i = 0; i < dados.length; i++) {
            dataxAxis.push(dados[i]['agrupador']);
            dataRealizado.push(dados[i]['realizado']);
            dataMeta.push(dados[i]['meta']);
            dataAnoAnterior.push(dados[i]['realizadoanoanterior']);
        }

        const option = {
            tooltip: {
                trigger: 'axis',
                valueFormatter: (value) => parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                axisPointer: {
                    type: "shadow"
                }
            },
            legend: {
                data: ['Realizado', 'Meta', 'Ano Anterior'],
                bottom: 'bottom',
            },
            grid: {
                top: '10%',
                left: '5%',
                right: '10%',
                bottom: '15%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: MesesAbreviados(dataxAxis)
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: function (value) {
                        var val = formatarValores(value);
                        return val;
                    },
                },
            },
            series: [
                {
                    name: 'Realizado',
                    type: 'line',
                    color: '#165BAA',
                    stack: 'Total',
                    data: dataRealizado
                },
                {
                    name: 'Meta',
                    type: 'line',
                    color: '#F3722C',
                    lineStyle: {
                        width: 2,
                        type: 'dashed'
                    },
                    stack: 'Total',
                    data: dataMeta
                },
                {
                    name: 'Ano Anterior',
                    type: 'line',
                    color: '#1AB394',
                    stack: 'Total',
                    data: dataAnoAnterior
                }
            ]
        }

        setOption(option);

    }, [dados]);

    function MesesAbreviados(meses) {
        return meses.map(mes => mes.slice(0, 3));
    }

    function formatarValores(valor) {
        if (valor >= 1000000) {
            return (valor / 1000000).toFixed(1) + "M";
        } else if (valor >= 1000) {
            return (valor / 1000).toFixed(0) + "K";
        } else {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        }
    }

    function formatarNomeMes(numeroMes) {
        const mes = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];

        return mes[numeroMes - 1];
    }

    return (
        <div className='card-linha'>
            <div className='card-header-linha font-titulo-linha'>
                <h4 className='uppercase'>{titulo}</h4>
                <span className='text-[10px]' style={{ color: '#888888' }}>{formatarNomeMes(mes)} {ano}</span>
            </div>
            {dados.length > 0 ? (
                <ApacheEcharts option={option} style={style} />
            ) : (
                <p className='p-info-linha font-titulo-linha'>Sem dados no momento!</p>
            )}
        </div>
    );
}

export default GraficoLinha